__turbopack_context__.v({
  "creditflowVariant": "searchResults-module-scss-module__yn3kfG__creditflowVariant",
  "noResults": "searchResults-module-scss-module__yn3kfG__noResults",
  "noSearchResults": "searchResults-module-scss-module__yn3kfG__noSearchResults",
  "resultsContainer": "searchResults-module-scss-module__yn3kfG__resultsContainer",
  "row": "searchResults-module-scss-module__yn3kfG__row",
  "searchText": "searchResults-module-scss-module__yn3kfG__searchText",
});
